<template>
  <div class="countries_all">
    <template>
      <Breadcrumb :items="items" />
      <!-- @filterFired="filterFired" -->
      <!-- <MainFilter
        @getResult="setRows"
        :reportType="'Debits'"
        :withSearch="true"
      /> -->
      <the-filter :inputs="inputs" />
      <template>
        <!-- Start Main Section -->
        <main class="magic-table-wrapper">
          <v-data-table
            class="thumb strip"
            :headers="headers"
            :items="rows"
            :loading="loading"
            :loading-text="$t('table.loadingData')"
            item-key="id"
            hide-default-footer
            :items-per-page="rows.length"
          >
            <!-- ================== You Can use any slots you want ================== -->
            <!-- ====== Select row field ====== -->
            <!-- Image -->
            <template v-slot:[`item.image`]="{ item }">
              <img @click="show_model_1" class="image" :src="item.image" />
            </template>
            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>

            <!-- Select no data State -->
            <template v-slot:no-data>
              {{ $t("table.noData") }}
            </template>

            <!-- IsActive -->
            <template v-slot:[`item.is_active`]="{ item }">
              <span class="status" :class="item.is_active ? 'paid' : 'unpaid'">
                {{ item.is_active ? "مفعل" : "معطل" }}
              </span>
            </template>

            <!-- Select actions-->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="_actions">
                <v-icon class="show" small @click="showItem(item)">
                  fal fa-eye
                </v-icon>
                <v-icon class="edit" small @click="editItem(item)">
                  fal fa-edit
                </v-icon>
                <v-icon class="delete" small @click="deleteItem(item)">
                  fal fa-trash
                </v-icon>
              </div>
            </template>

            <!-- ======================== Start Top Section ======================== -->

            <!-- ======================== End Top Section ======================== -->
          </v-data-table>
        </main>
        <!-- End Main Section -->

        <!-- Start Pagination -->
        <!-- <template>
          <div
            class="pagination_container text-center mb-5 d-flex justify-content-end"
          >

            <v-pagination
              color="primary"
              v-model="paginations.current_page"
              :length="paginations.last_page"
              :total-visible="5"
              @input="fetchData($event)"
            ></v-pagination>
          </div>
        </template> -->
        <!-- End Pagination -->

        <!-- Start Image_Model -->
        <base-model
          @closeModel="model_1.show_model = false"
          :show="model_1.show_model"
        >
          <div class="image">
            <img
              v-if="model_1.model_img_src"
              :src="model_1.model_img_src"
              alt="..."
            />
          </div>
        </base-model>
        <!-- End Image_Model -->
      </template>
      <!-- :custom-filter="helper_filterSearch" -->
    </template>
  </div>
</template>

<script>
// import MainFilter from "@/components/Filters/ReportFilter.vue";
import TheFilter from "@/components/Filters/TheFilter.vue";
import { mapGetters } from "vuex";
export default {
  components: { TheFilter },
  data() {
    return {
      // breadcrumb
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: "المديونيات",
          disabled: true,
          href: "",
        },
      ],
      button_: {
        id: "",
      },

      // ========== Filter
      inputs: [
        {
          keyName: "keyword",
          type: "student",
        },
        {
          keyName: "user_type",
          user_types: [
            {
              id: "client",
              name: "عميل",
            },
            {
              id: "restaurant",
              name: "مطعم",
            },
            {
              id: "driver",
              name: "سائق",
            },
          ],
        },
        {
          keyName: "start_date",
          value: new Date(
            new Date().getFullYear(),
            new Date().getMonth() - 1,
            2
          )
            .toISOString()
            .slice(0, 10),
        },
        {
          keyName: "end_date",
          value: new Date().toISOString().slice(0, 10),
        },
      ],
      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,

      // ========== Model
      model_1: {
        show_model: false,
        model_img_src: "",
      },
      loading: false,
      rows: [],
      statistics: [],
      search: null,
      expandData: null,
      selected: [],
      singleSelect: false,
      order_types: [
        {
          id: "client",
          name: "عميل",
        },
        {
          id: "restaurant",
          name: "مطعم",
        },
        {
          id: "driver",
          name: "سائق",
        },
      ],
      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },
    };
  },

  methods: {
    mapItem(data) {
      this.expandData = {
        [this.$t("labels.created_at")]: data.created_at,
      };
    },
    setRows() {
      const getInputValue = (key) => {
        const input = this.inputs.find((i) => i.keyName === key);
        return input ? input.value : null;
      };

      this.$axios({
        method: "GET",
        url: "report/indebtedness",
        params: {
          // page: this.paginations.current_page,
          keyword: this.$route.query.keyword ? this.$route.query.keyword : "",
          user_type: this.$route.query.user_type
            ? this.$route.query.user_type
            : "client",
          from: this.$route.query.start_date || getInputValue("start_date"),
          to: this.$route.query.end_date || getInputValue("end_date"),
          // payment_method: this.$route.query.payment_method,
        },
      })
        .then((res) => {
          // this.paginations.last_page = res.data.meta?.last_page;
          // this.paginations.items_per_page = res.data.meta?.per_page;
          // this.total = res.data.meta?.total;
          this.rows = res.data.data;
          this.loading = false;
          // console.log(res);

          // this.statistics = [];
          // for (const [key, value] of Object.entries(res.data.data)) {
          //   this.statistics.push({
          //     title: this.$t(key),
          //     count: value,
          //   });
          // }
        })
        .catch((err) => {
          // console.log(err.response.data.messages);
          let message =
            err.response?.data.message ?? err.response?.data.messages;
          this.$iziToast.error({
            title: this.$t("validation.error"),
            message: message,
          });
          this.loading = false;
        });
    },
    imageError(index) {
      if (this.rows[index].partner) {
        this.rows[
          index
        ].partner.vehicle.image = require("@/assets/images/icons/no-data.gif");
      }
    },

    showItem(item) {
      this.$router.push({ path: `/trips/show/` + item.id });
    },

    fetchData(e) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: e }),
      });
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      this.setRows();
    },
    getUser(user) {
      if (user == "client") return "العملاء";
      if (user == "restaurant") return "المطاعم";
      if (user == "driver") return "السائقين";
    },
    handleRouteChange() {
      // Only handle the page parameter for this component
      const { page } = this.$route.query;

      // Update pagination
      this.paginations.current_page = page ? +page : 1;

      // Call setRows with nextTick to ensure all data is updated
      this.$nextTick(() => {
        this.setRows();
      });
    },
  },
  watch: {
    $route: {
      handler() {
        this.handleRouteChange();
      },
      immediate: true, // This will make the watcher run when the component is created
    },
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    jsonFields() {
      return {
        الاسم: "full_name",
        العنوان: "title_trans",
        الهاتف: "phone_complete_form",
        المبلغ: "balance",
        التاريخ: "created_at",
      };
    },

    headers() {
      if (this.lang == "ar") {
        return [
          {
            text: "#",
            align: "center",
            value: "index",
            sortable: true,
          },
          {
            text: "الاسم",
            value: "full_name",
            align: "center",
          },
          {
            text: "العنوان",
            value: "title_trans",
            align: "center",
          },
          {
            text: "الهاتف",
            value: "phone_complete_form",
            align: "center",
          },
          {
            text: "المبلغ",
            value: "balance",
            align: "center",
          },
          {
            text: "التاريخ",
            value: "created_at",
            align: "center",
          },
          // {
          //   text: "التحكم",
          //   value: "actions",
          //   align: "center",
          //   sortable: false,
          // },
        ];
      } else {
        return [
          {
            text: "#",
            align: "center",
            value: "id",
            sortable: true,
          },
          {
            text: "image",
            align: "center",
            value: "image",
            sortable: false,
          },
          { text: "Name", value: "fullname", align: "center" },
          {
            text: "Email",
            value: "email",
            align: "center",
          },
          {
            text: "Phone",
            value: "phone",
            align: "center",
          },
          {
            text: "Active?",
            value: "is_active",
            align: "center",
          },
          {
            text: "Permission",
            value: "role",
            align: "center",
          },
          {
            text: "control",
            value: "actions",
            align: "center",
            sortable: false,
          },
        ];
      }
    },
  },

  created() {
    this.control = this.$permission.setControls(this.$route.path);
    // Removed redundant handleRouteChange() since watcher is immediate
  },
};
</script>
